// extracted by mini-css-extract-plugin
export default {"marketing-blog-container":"marketing-blog-container_config_KcMw"};